module.exports = __webpack_public_path__ + "img/tu3.f3e58ad0.jpg";